import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const HreflangTags = () => {
  const location = useLocation();

  useEffect(() => {
    // Remove existing hreflang tags
    const existingTags = document.querySelectorAll('link[rel="alternate"]');
    existingTags.forEach(tag => tag.remove());

    // Get current path without language prefix
    const currentPath = location.pathname;
    let basePath = currentPath;
    
    // Remove language prefix if it exists
    if (currentPath.startsWith('/en/') || currentPath.startsWith('/es/')) {
      basePath = currentPath.substring(3); // Remove /en or /es
    } else if (currentPath === '/en' || currentPath === '/es') {
      basePath = '/';
    }

    // Base URL
    const baseUrl = 'https://amawellness.es';
    
    // Create hreflang URLs
    const urls = {
      en: basePath === '/' ? `${baseUrl}/en` : `${baseUrl}/en${basePath}`,
      es: basePath === '/' ? `${baseUrl}/es` : `${baseUrl}/es${basePath}`,
      default: basePath === '/' ? `${baseUrl}/` : `${baseUrl}${basePath}`
    };

    // Create and append hreflang tags
    const createHreflangTag = (hreflang, href) => {
      const link = document.createElement('link');
      link.rel = 'alternate';
      link.hreflang = hreflang;
      link.href = href;
      return link;
    };

    // Add tags to head
    const head = document.head;
    head.appendChild(createHreflangTag('en', urls.en));
    head.appendChild(createHreflangTag('es', urls.es));
    head.appendChild(createHreflangTag('x-default', urls.default));

    console.log('Hreflang tags added:', {
      en: urls.en,
      es: urls.es,
      default: urls.default
    });

    // Cleanup function
    return () => {
      const tagsToRemove = document.querySelectorAll('link[rel="alternate"]');
      tagsToRemove.forEach(tag => tag.remove());
    };
  }, [location.pathname]);

  return null; // This component doesn't render anything visible
};

export default HreflangTags;
